// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__tD3tt","active":"Tab_active__ObZ4s"};